import { shallowEqual, useSelector } from "react-redux";

export function getCustomerUser({ state }) {
  return state?.auth?.customer?.user;
}

export function getCustomerUserCredentials({ state }) {
  return state?.auth?.customer?.creds;
}

export function getCurrentUsers({ store }) {
  const state = store.getState();

  return {
    customer: {
      user: getCustomerUser({ state }),
      signInPath: "/customer/auth",
    },
  };
}

export default function useCustomerUser() {
  return useSelector((state) => getCustomerUser({ state }), shallowEqual);
}

export function customerUserCredentials() {
  return useSelector(
    (state) => getCustomerUserCredentials({ state }),
    shallowEqual
  );
}
